module.exports = __webpack_public_path__ + "img/hs.55c54ffc.png";